import React from 'react';
import { useIsMobile } from '~/hooks/useIsMobile.ts';
import {
  CompanyDepositProvisionalType,
  CompanyDepositType,
} from '~/types/resources/CompanyDepositType.ts';
import { CompanyDepositCard } from '../Card';
import styles from './styles.module.scss';

type Props = {
  rows: (CompanyDepositProvisionalType | CompanyDepositType)[];
};

export const CompanyDepositCardList: React.FC<Props> = ({ rows }) => {
  const isMobile = useIsMobile();
  return rows.length === 0 ? (
    <div className={styles.emptyTable}>データなし</div>
  ) : (
    <>
      {isMobile && <div className={styles.header}>月次レポート</div>}
      <div className={styles.cardList}>
        {rows.map((row, key) => (
          <CompanyDepositCard row={row} key={key} />
        ))}
      </div>
    </>
  );
};
